'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Th: ()=>Th
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_Th_variants_cjs_namespaceObject = require("./Th.variants.cjs");
const external_cleanTableProps_cjs_namespaceObject = require("../cleanTableProps.cjs");
const index_cjs_namespaceObject = require("../Table/index.cjs");
const external_THead_index_cjs_namespaceObject = require("../THead/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../../Tooltip/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const iconNameMap = {
    ascending: 'north',
    descending: 'south',
    unsorted: 'unfold_more'
};
function Th({ children, className, onClick, ...props }) {
    const { headerCellInteractive: tableHeaderCellInteractive, firstColumnSticky, bordered: tableBordered } = (0, index_cjs_namespaceObject.useTableContext)();
    const { interactive: tableHeadInteractive } = (0, external_THead_index_cjs_namespaceObject.useTableHeadContext)();
    const { interactive: headCellInteractive } = props;
    const interactive = headCellInteractive ?? tableHeadInteractive ?? tableHeaderCellInteractive;
    const classes = (0, external_utils_index_cjs_namespaceObject.cn)((0, external_Th_variants_cjs_namespaceObject.thVariants)({
        ...props,
        interactive,
        firstColumnSticky,
        tableBordered
    }), className);
    const contentClasses = (0, external_Th_variants_cjs_namespaceObject.contentVariants)(props);
    const { description, sort = 'disabled' } = props;
    const iconName = iconNameMap[sort] || 'unfold_more';
    const cleanedProps = (0, external_cleanTableProps_cjs_namespaceObject.cleanTableProps)(props);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("th", {
        className: classes,
        onClick: onClick,
        ...cleanedProps,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: contentClasses,
            children: [
                children,
                description && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                    side: "top",
                    triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                        iconName: "info"
                    }),
                    children: description
                }),
                'disabled' !== sort && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                    iconName: iconName
                })
            ]
        })
    });
}
exports.Th = __webpack_exports__.Th;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Th"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
